module.exports = "https://static.zego.com/_next/static/images/next-arrow-e4aa82401cde5e90822c4cbbfac33bc5.svg";